import React from "react";
import styled from "styled-components";

// Breakpoints
const breakpoints = {
  sm: "576px",
  md: "768px",
  lg: "992px",
  xl: "1200px",
};

// Wrapper for the entire section
const Container = styled.section`
  padding-left: 2rem;
  padding-right: 2rem;
  max-width: 1200px;
  // margin: 0 auto;
  box-sizing: border-box;

  @media (max-width: ${breakpoints.md}) {
    padding-top: 2rem;
  }
`;

// Title
const Title = styled.h2`
  font-family: Verdana, Arial, sans-serif;
  font-size: 1rem;
  margin-bottom: 2rem;
  text-align: left;

  @media (max-width: ${breakpoints.md}) {
    font-size: 1.3rem;
  }
`;

// Flex row
const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  align-items: flex-start;
  justify-content: flex-start;
  padding-left: 1rem;
  padding-right: 1rem;

  @media (min-width: ${breakpoints.md}) {
    padding-left: 8rem;
    padding-right: 2rem;
  }
`;

// Left Column (Image)
const LeftColumn = styled.div`
  width: 220px;
  flex: 0 0 auto;

  img {
    width: 220px;
    height: 306px;
    display: block;
  }
`;

// Right Column (Text)
const RightColumn = styled.div`
  flex: 1 1 35%;
  min-width: 200px;
  max-width: 500px;
  margin-bottom: 3rem;

  .text-block {
    color: black;
    font-size: 0.9rem;
    line-height: 1.4;

    @media (max-width: ${breakpoints.sm}) {
      font-size: 1rem;
    }

    b {
      font-weight: bold;
      display: block;
      margin-bottom: 0.5rem;
      font-size: 1.05rem;
    }
  }
`;

const ArtisticMovementsAndPhenomena: React.FC = () => {
  return (
    <Container>
      <Title>UMETNIČKI PRAVCI I POJAVE</Title>
      {/* <Row>
        <LeftColumn>
          <a href="/g/avangarda">
            <img
              src="images/04_avangarda_srednja2.jpg"
              alt="avangarda, citajte o"
            />
          </a>
        </LeftColumn>
        <RightColumn>
          <div>
            <b>AVANGARDA</b>- U februaru počinje da izlazi časopis Zenit –
            Internacionalna revija za umetnost i kulturu. Urednik Ljubomir
            Micić. U prvom broju časopisa Zenit izlazi Zenitistički manifest
            Ivana Golla pisan na nemačkom i Manifest zenitizma čiji su
            potpisnici Ljubomir Micić, Ivan Goll i Boško Tokin. Zenit
            uspostavlja aktivnu saradnju sa Arhipenkom osnivačem umetničke škole
            u Berlinu.
            <br></br>- Branko Ve Poljsnski i Dragan Aleksić u Pragu priređuju
            zenitističke i dadaističke manifestacije. Osnovan umetnički klub
            Zenit.
            <br></br>- Zenitovi saradnici u prvoj polovini godine objavljuju
            značajna dela: Rastko Petrović Bruleska gospodina Peruna boga groma,
            Miloš Crnjanski Dnevnik o Čarnojeviću, Stanislav Vinaver Gromobran
            Svemira, Miroslav Krleža Marginalije uz slike Petra Dobrovića.
            Izlazi revija za filmsku kulturu Kinofon, urednik Valerij Poljanski
          </div>
        </RightColumn>
      </Row> */}
      <Row>
        <LeftColumn>
          <a href="/g/avangarda">
            <img
              src="images/04_avangarda_srednja2.jpg"
              alt="avangarda, citajte o"
            />
          </a>
        </LeftColumn>
        <RightColumn>
          <div>
            <b>AVANGARDA</b>- U februaru počinje da izlazi časopis Zenit –
            Internacionalna revija za umetnost i kulturu. Urednik Ljubomir
            Micić. U prvom broju časopisa Zenit izlazi Zenitistički manifest
            Ivana Golla pisan na nemačkom i Manifest zenitizma čiji su
            potpisnici Ljubomir Micić, Ivan Goll i Boško Tokin. Zenit
            uspostavlja aktivnu saradnju sa Arhipenkom osnivačem umetničke škole
            u Berlinu.
          </div>
          <a href="/g/avangarda">dalje...</a>
          <a href="/g/avangarda">
            <img
              src="images/strelica.jpg"
              alt="Strelica"
              width="15"
              // class="sc-koXPp eEfYTM"
            />
          </a>
        </RightColumn>
      </Row>{" "}
      <Row>
        <LeftColumn>
          <a href="/g/konceptualna-umetnost">
            <img
              src="/images/g/Naslovna foto konceptualna_2.jpg"
              alt="konceptualna umetnost, citajte o"
            />
          </a>
        </LeftColumn>
        <RightColumn>
          <div>
            <b>KONCEPTUALNA UMETNOST</b>- Hronologija konceptualne umetnosti u
            Jugoslaviji
          </div>
          <a href="/g/konceptualna-umetnost">dalje...</a>
          <a href="/g/konceptualna-umetnost">
            <img src="images/strelica.jpg" alt="Strelica" width="15" />
          </a>
        </RightColumn>
      </Row>
    </Container>
  );
};

export default ArtisticMovementsAndPhenomena;
